<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="distributionUsersSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="distributionUsersItems"
    :loading="distributionUsersLoading"
    :search-input.sync="distributionUsersSearch"
    item-text="Description"
    item-value="id"
    :label="$t('DistributionUser.ObjectName')"
    return-object
  ></v-autocomplete>
</template>

<script>
import DistributionUsers from "@/api/distribution_users";

export default {
  name: "SearcherDistributionUser",

  props: {
    value:Array,
    searcherStocks:Array
  },

  computed: {
    distributionUsersItems() {
      return this.distributionUsers.map((distributionUser) => {
        const Description = distributionUser.name
        
        return Object.assign({}, distributionUser, { Description });
      });
    },
  },

  data: () => ({
    distributionUsers: [],
    distributionUsersLoading: false,
    distributionUsersSearch: "",
    distributionUsersSelected: [],
  }),

  mounted() {
    this.getDistributionFromAPI()
  },
  methods:{
    getDistributionFromAPI(){
      this.distributionUsersLoading = true;
      DistributionUsers.fetchAllForSelect({
        stock_id: this.searcherStocks
      })
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distributionUsers = response.data.distributionUsers;
          }
          this.distributionUsersLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.distributionUsersLoading = false;
        }.bind(this)
      );
    }
  },
  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.distributionUsersSelected = this.value;
      },
    },
    distributionUsersSelected: {
      handler() {
        this.$emit("input", this.distributionUsersSelected);
      },
    },
    searcherStocks:{
      handler(){
            this.getDistributionFromAPI()
      }
    }
  },
};
</script>